import { Export } from "@dto/pageResponse.dto";

export abstract class Const {
  /**
   * For daily graph and heatmap refresh rate
   */
  static readonly TIMEOUT_SHORT = 1000 * 60 * 10;
  /**
   * For non-daily graphs refresh rate
   */
  static readonly TIMEOUT_LONG = 1000 * 60 * 60;

  /**
   * Short change events e.g. mouse click
   */
  static readonly TIMEOUT_DEBOUNCE_SHORT = 400;
  /**
   * Long change events e.g. keyboard input
   */
  static readonly TIMEOUT_DEBOUNCE_LONG = 800;

  /**
   * 1970-04-26T17:46:39.999Z
   */
  static readonly MIN_UNIX_TIME = 9999999999;
  /**
   * Logs view refresh rate
   */
  static readonly TIMEOUT_LOG = 10000;

  static readonly DEFAULT_EXPORT: Omit<Export, "body"> = {
    fileName: "export",
    method: "POST",
    url: "/api/exporter/v1/values"
  } as const;
}